import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { showError, showSuccess } from "ReduxErrorBar";
import Pagination from "react-js-pagination";
import { itemCount, COMMON_FAIL_MESSAGE } from "Constants";
import ListItem from "SpeakersListItem";
import NoContent, { NO_SPEAKER } from "NoContent";
import LocaleStrings from "Languages";
import { confirmAlert } from "react-confirm-alert";
import { deleteAllSpeakers, deleteBulkSpeakers } from "ActionsSpeakers";

class SpeakersListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedUsers: [],
      allCheck: false,
      actionOption: false,
    };
    this.paginationCallback = this.paginationCallback.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.afterpagi) {
      this.callfromParent();
      this.props.makepagistopped();
    }
  }

  additionCallback = () => {
    this.props.finishOperationsCallback();
  };

  paginationCallback = (pageNumber) => {
    this.props.paginationCallback(pageNumber);
  };

  renderList() {
    let { pageNumber, speakers } = this.props;
    let pageDataLength =
      speakers.data && speakers.data.length > 0 ? speakers.data.length : 1;

    var items = _.map(speakers.data, (speaker) => (
      <ListItem
        key={speaker.speakerid}
        speaker={speaker}
        pagination={this.paginationCallback}
        operationsCallback={this.additionCallback}
        pageDataLength={pageDataLength}
        currentPage={pageNumber}
        checkAndUncheckUsers={this.updateSelectedUser}
        selectedUsers={this.state.selectedUsers}
      />
    ));
    return items;
  }

  selectAllUsers = () => {
    var state = this.state.allCheck;
    var selectedUsers = this.state.selectedUsers;
    var allUsers = this.props.speakers.data;
    var newSelectUser = [];
    var newSelectedUsers = [];

    if (state == false) {
      _.map(allUsers, (user) => {
        var checkUserExitOrNot = _.filter(selectedUsers, function (selusers) {
          return selusers.speakerid === user.speakerid;
        });
        //Check if user is not exist in selected user that add
        if (checkUserExitOrNot.length == 0) {
          newSelectUser = { ...user, checked: true };
          selectedUsers = [...selectedUsers, newSelectUser];
        }
        this.checkMatchArray(selectedUsers);
        this.setState({ selectedUsers });
      });
    } else {
      var leftUsers = selectedUsers;
      _.map(allUsers, (user) => {
        newSelectedUsers = _.filter(leftUsers, function (selusers) {
          return selusers.speakerid !== user.speakerid;
        });
        leftUsers = newSelectedUsers;
        this.checkMatchArray(leftUsers);
        this.setState({ selectedUsers: leftUsers });
      });
    }
  };

  updateSelectedUser = (user) => {
    var selectedUsers = this.state.selectedUsers;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.speakerid === user.speakerid;
    });

    if (index >= 0) {
      var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
        return selusers.speakerid !== user.speakerid;
      });

      this.checkMatchArray(newSelectedUsers);
      this.setState({ selectedUsers: newSelectedUsers });
    } else {
      if (!user.deleted) {
        var newSelectUser = { ...user, checked: true };
        selectedUsers = [...selectedUsers, newSelectUser];
      }

      this.checkMatchArray(selectedUsers);
      this.setState({ selectedUsers });
    }
  };

  callfromParent() {
    var selectedUsers = this.state.selectedUsers;
    this.checkMatchArray(selectedUsers);
  }

  checkMatchArray = (selectedUsers) => {
    setTimeout(() => {
      var userList = this.props.speakers.data;

      var newArray = [];
      _.map(userList, (appUser) => {
        var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
          return selusers.speakerid === appUser.speakerid;
        });

        if (newSelectedUsers && newSelectedUsers.length > 0) {
          // newArray = [...newArray, newSelectedUsers];
          newArray.push(newSelectedUsers[0]);
        }
      });

      // Check for current page selection and according to show or hide action option for bulk email send

      // Check for all user selected or not according to that check or uncheck master check option
      if (newArray.length > 0 && newArray.length === userList.length) {
        this.setState({ allCheck: true });
      } else {
        this.setState({ allCheck: false });
      }
    }, 100);
  };

  clearAllData = (e) => {
    this.setState({
      selectedUsers: [],
      allCheck: false,
    });
  };

  // Bulk delete appusers
  bulkDeleteSpeakers = () => {
    let { selectedUsers, pageNumber } = this.state;

    let deleteData = [];
    selectedUsers.map((val, index) => {
      let obj = {};
      obj.speakerid = val.speakerid;
      deleteData.push(obj);
    });

    /**
     * Calculation for current page no. in pageination select
     */
    let leftRecord = this.props.speakers.count - selectedUsers.length;
    var pageCount = Math.floor(leftRecord / itemCount);
    var pageExtraCount = Math.floor(leftRecord % itemCount);

    if (pageExtraCount > 0) {
      pageCount = pageCount + 1;
    }

    let newPageNo = pageNumber;
    if (pageNumber > pageCount) {
      newPageNo = pageCount;
    }

    confirmAlert({
      title: LocaleStrings.speaker_title_delete_speakers,
      message: _.replace(
        LocaleStrings.speaker_delete_speakers_subtitle,
        "#total",
        selectedUsers.length
      ),
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteBulkSpeakers(
              this.props.session,
              deleteData,
              (response) => {
                if (response.success === 0) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.paginationCallback(newPageNo);
                  this.props.showSuccess(
                    LocaleStrings.user_message_user_deleted
                  );
                  this.clearAllData();
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  deleteAllSpeakers() {
    confirmAlert({
      title: LocaleStrings.speaker_title_delete,
      message: LocaleStrings.speaker_text_are_you_sure_delete,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteAllSpeakers(this.props.session, (response) => {
              if (response.success === 0) {
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.props.finishOperationsCallback();
                this.props.showSuccess(LocaleStrings.speaker_message_deleted);
              }
            });
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  render() {
    let { speakers } = this.props;
    let { allCheck, selectedUsers } = this.state;

    if (speakers.data && speakers.data.length === 0) {
      return <NoContent contentType={NO_SPEAKER} />;
    } else {
      return (
        <div className="sponsor-content">
          <div className="vertical-align-center">
            <ul className="select-all-checkbox-section">
              <li>
                <label className="custom-container-checkbox">
                  <input
                    type="checkbox"
                    onChange={this.selectAllUsers}
                    checked={allCheck}
                  />
                  <span className="checkmark" />
                </label>
              </li>
              <li>
                <span style={{ fontWeight: "bold", marginRight: 15 }}>
                  {LocaleStrings.user_option_select_all}
                </span>
              </li>
            </ul>
            {selectedUsers.length > 0 ? (
              <div className="ml-10">
                <span>
                  {_.replace(
                    LocaleStrings.speaker_text_total_selected_speaker,
                    "#total",
                    selectedUsers.length
                  )}
                </span>
                <span className="ml-10 mr-10">|</span>
                <span
                  className="text-primary cursor-pointer ml-10"
                  onClick={() => this.bulkDeleteSpeakers()}
                >
                  {_.replace(
                    LocaleStrings.speaker_delete_selected_speaker,
                    "#total",
                    selectedUsers.length
                  )}
                </span>

                {allCheck && selectedUsers.length != speakers.count ? (
                  <>
                    <span className="ml-10 mr-10">|</span>
                    <span
                      className="text-primary cursor-pointer ml-10"
                      onClick={() => this.deleteAllSpeakers()}
                    >
                      {speakers.count == selectedUsers.length
                        ? LocaleStrings.speaker_text_clear_all_selected_speakers
                        : _.replace(
                            LocaleStrings.speaker_text_select_all_speakers,
                            "#total",
                            speakers.count
                          )}
                    </span>
                  </>
                ) : (
                  ""
                )}
              </div>
            ) : null}
          </div>
          <table className="table">
            <thead>
              <tr>
                <th style={{ width: "3%" }}>#</th>
                <th>{LocaleStrings.speaker_name}</th>
                <th>{LocaleStrings.speaker_th_company}</th>
                <th>{LocaleStrings.speaker_th_title}</th>
                <th>{LocaleStrings.speaker_th_action}</th>
              </tr>
            </thead>
            <tbody className="tbody-background">{this.renderList()}</tbody>
          </table>

          {speakers && speakers.count > itemCount ? (
            <Pagination
              activePage={this.props.pageNumber}
              itemsCountPerPage={itemCount}
              totalItemsCount={speakers.count}
              pageRangeDisplayed={10}
              onChange={this.props.paginationCallback}
              style={{ float: "right" }}
            />
          ) : null}
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    speakers: state.speakers,
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  deleteAllSpeakers,
  showError,
  showSuccess,
  deleteBulkSpeakers,
})(SpeakersListing);
